var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"modal",attrs:{"hide-footer":"","size":"lg","centered":"","id":"login-modal"},on:{"show":_vm.show}},[_c('LoginForm')],1)}
var staticRenderFns = []

export { render, staticRenderFns }